import axiosWrapper from './axiosWrapper';

/**
 * AI analysis endpoints (proxied through the Node server to the Python service).
 */
const analysisService = {
  /**
   * Analyze the sentiment of a block of text.
   * @param {string} text - The text to analyze
   * @returns {Promise<{data: {label: string, confidence: number, probabilities: Object}|null, error: *}>}
   */
  async analyzeSentiment(text) {
    return axiosWrapper({
      method: 'post',
      path: 'analysis/sentiment',
      data: { text },
      optimistic: false,
    });
  },
};

export default analysisService;
